import { useEffect, useState } from 'react';
import { fetchData, styles } from './Helpers';
import { freeWImg, privateImg, professionalImg, globalImg, amersImg, emeaImg, apacImg, licenseTypeImg, timelineImg, packageImg, tickImg, crossImg, resolveImage } from "../../images/ImageResolver";

function PliDropdown({pliData}) {
  return(
    <div>
      <ef-layout className="wealth-detail-layout">
        <ef-layout flex>
          <ef-layout flex className="wealth-detail-banner">
            <ef-layout>
              <h5>{pliData ? pliData.licenseType : ""}</h5>
              <span>License Type</span>
            </ef-layout>
            <ef-layout>
              <img src={licenseTypeImg} alt="License Type" />
            </ef-layout>
          </ef-layout>
          <ef-layout flex className="wealth-detail-banner">
            <ef-layout>
              <h5>{pliData ? pliData.timelines : ""}</h5>
              <span>Timeline</span>
            </ef-layout>
            <ef-layout>
              <img src={timelineImg} alt="Timeline" />
            </ef-layout>
          </ef-layout>
          <ef-layout flex className="wealth-detail-banner">
            <ef-layout>
              <h5>{pliData ? pliData.packageParameter.split("=")[1] : ""}</h5>
              <span>Package Parameter</span>
            </ef-layout>
            <ef-layout>
              <img src={packageImg} alt="Package Parameter" />
            </ef-layout>
          </ef-layout>
        </ef-layout>
        <ef-layout className="comment-layout">
          <table>
            <thead>
              <tr>
                <th>Material Name</th>
                <th>Material Code</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{pliData.materialName}</td>
                <td>{pliData.materialCodes}</td>
              </tr>
            </tbody>
          </table>
        </ef-layout>
      </ef-layout>
    </div>
  )
}

function Package({type, pliData, segmentationData}) {
  const [tab, setTab] = useState("pli");
  const [ddIndex, setDdIndex] = useState(0);
  useEffect(() => {
    const grid = document.getElementById('grid');
    const columns = [
      { name: 'SEGMENTS', field: 'segments', width: 4, scalable: true },
      { name: 'PUBLIC', field: 'public', width: 6, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "free"), binding: textWithIcon, styles: styles, visible: type === "Redistribution Public (Free-to-Air)" ? true : false },
      { name: 'PRIVATE', field: 'private', width: 6, scalable: true, headerBinding: headerWithLink.bind(null, "Non Professional", "private"), binding: textWithIcon, visible: type === "Redistribution Private" ? true : false},
      { name: 'INTERNAL PROFESSIONAL', field: 'professional', width: 6, scalable: true, headerBinding: headerWithLink.bind(null, "Private", "professional"), binding: textWithIcon, styles: styles, visible: type === "Internal Professional" ? true : false }
    ]

    function headerWithLink(text, i, e) {
      let cell = e.cell;
      let content = cell.getContent();
      if(!content || !content._myHeaderWithLink) {
        content = document.createElement("div");
        content._myHeaderWithLink = true;
        let span = content._span = document.createElement("span");
        span.style.marginRight = "5px";
        let image = content._span1 = document.createElement("img");
        image.style.position = "absolute";
        image.style.top = "10px";
        image.style.right = "5px";
        image.style.width = "38px";
        image.src = resolveImage(i);
        let span2 = content._span2 = document.createElement("span");
        span2.style.display = "block";
        span2.style.fontWeight = 400;
        content.appendChild(span);
        content.appendChild(span2);
        content.appendChild(image);
      }

      content._span.textContent = e.columnDef.getName();
      content._span2.textContent = text;
      cell.setContent(content);
    };

    function textWithIcon(e) {
      let cell = e.cell;
      let content = cell.getContent();
      if (!content) {
        content = document.createElement("div");
        content.className = 'icon-cell';
        content.style.textAlign = "center";
        let span = document.createElement("span");
        span.className = 'icon-cell__text';
        span.style.overflow = 'hidden';
        span.style.textOverflow = 'ellipsis';
        span.style.whiteSpace = 'nowrap';
        span.style.maxWidth = '100%';
        span.style.display = "inline-block";
        span.style.fontWeight = 400;
        content.appendChild(span);
        let img = document.createElement("img");
        img.className = 'icon-cell__img';
        img.width = 16;     // tweak as needed
        img.height = 16;    // tweak as needed
        img.decoding = 'async';
        img.loading = 'eager';
        content.appendChild(img);
        cell.setContent(content);
      }

      const value = String(e.data).toLowerCase();
      const imgEl = content.querySelector('.icon-cell__img');
      const span = content.querySelector('.icon-cell__text');
      if(value === 'x') {
        imgEl.style.display = "inline-block";
        imgEl.src = tickImg;
        span.style.display = "none";
      }else if(value === '' || value === 'na' || value === 'n/a') {
        imgEl.style.display = "inline-block";
        imgEl.src = crossImg;
        span.style.display = "none";
      }else {
        imgEl.style.display = "none";
        span.style.display = "inline-block";
        span.title = e.data;
        span.textContent = e.data;
      }
    }

    if(tab === "segmentation") {
      grid.config = {
        rowHeight: 60,
        headerRowHeight: 60,
        columns: columns,
        dataModel: {
          data: segmentationData
        },
        sorting: {
          sortableColumns: false,
          initialSort: {
            colIndex: 0, // Column index
            sortOrder: "a"
          }
        },
      };
    }
  }, [tab, segmentationData, type]);

  return(
    <div className='public-div'>
      <ef-tab-bar level="3">
        <ef-tab label="PLI" value="tab1" active onClick={() => setTab("pli")}></ef-tab>
        <ef-tab label="Segmentation" value="tab2" onClick={() => setTab("segmentation")}></ef-tab>
        <ef-tab label="Endpoints" value="tab3" onClick={() => setTab("endpoints")}></ef-tab>
      </ef-tab-bar>
      <ef-layout className="package-layout">
        {tab === "pli" &&<ef-layout>
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 1 ? 0 : 1)}>
            <ef-panel spacing>
              <img src={globalImg} alt="Global" />
              <span>Global</span>
              {ddIndex !== 1 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 1 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 1 && <PliDropdown pliData={pliData.filter(item => item.regions === "Global" && item.packageType.trim() === type)[0]} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 2 ? 0 : 2)}>
            <ef-panel spacing>
              <img src={amersImg} alt="AMERS" />
              <span>AMERS</span>
              {ddIndex !== 2 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 2 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 2 && <PliDropdown pliData={pliData.filter(item => item.regions === "AMERS" && item.packageType.trim() === type)[0]} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 3 ? 0 : 3)}>
            <ef-panel spacing>
              <img src={emeaImg} alt="EMEA" />
              <span>EMEA</span>
              {ddIndex !== 3 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 3 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 3 && <PliDropdown pliData={pliData.filter(item => item.regions === "EMEA" && item.packageType.trim() === type)[0]} />}
          <ef-layout className="inner-layout" onClick={() => setDdIndex(ddIndex === 4 ? 0 : 4)}>
            <ef-panel spacing>
              <img src={apacImg} alt="APAC" />
              <span>APAC</span>
              {ddIndex !== 4 && <ef-icon icon="down"></ef-icon>}
              {ddIndex === 4 && <ef-icon icon="up"></ef-icon>}
            </ef-panel>
          </ef-layout>
          {ddIndex === 4 && <PliDropdown pliData={pliData.filter(item => item.regions === "APAC" && item.packageType.trim() === type)[0]} />}
        </ef-layout>}
        {tab === "segmentation" && <efx-grid id="grid" className="entity-grid"></efx-grid>}
        {tab === "endpoints" && <ef-layout className="est-endpoints-inner-layout" >
          <span>Endpoints</span>
          {pliData.filter(item => item.regions === "Global" && item.packageType.trim() === type)[0].endpoints.split("\n").map(endpoint => (
            <p key={endpoint}>{endpoint}<ef-icon icon="copy"></ef-icon></p>
          ))}
        </ef-layout>}
      </ef-layout>
    </div>
  );
}

export default function WealthPackages() {
  const [packageLayout, setPackageLayout] = useState("free");
  const [pliData, setPliData] = useState([]);
  const [segmentationData, setSegmentationData] = useState([]);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    fetchData("Est_Wealth_Packages").then(res => {
      setPliData(res);
      setDataLoaded(true);
    });
    fetchData("Est_Segmentation").then(res => {
      setSegmentationData(res);
      setDataLoaded(true);
    });
  }, []);

  useEffect(() => {
    const buttonBar = document.getElementById('wealthBar');
    buttonBar.addEventListener('click', (event) => {
      let buttonId = '';
      if(event.target.getAttribute('id')) {
        buttonId = event.target.getAttribute('id');
      }else {
        buttonId = event.target.parentElement.getAttribute('id');
      }
      const buttons = buttonBar.querySelectorAll('ef-button');
      buttons.forEach(btn => {
        btn.active = false;
        btn.children[0].src = resolveImage(btn.getAttribute('id'));
      });
      const btn = document.getElementById(buttonId);
      btn.active = true;
      btn.children[0].src = resolveImage(`${buttonId}-w`);
      setPackageLayout(buttonId);
    });
  }, []);

  return (
    <div className='wealth-packages'>
      <ef-loader class="loader" hidden={dataLoaded}></ef-loader>
      <h4>WEALTH PACKAGES</h4>
      <ef-layout flex>
        <ef-layout>
          <ef-button-bar id="wealthBar">
            <ef-button-bar managed>
              <ef-button id="free" toggles active><img src={freeWImg} alt="Public"/>Public</ef-button>
              <ef-button id="private" toggles><img src={privateImg} alt="Private"/>Private</ef-button>
              <ef-button id="professional" toggles><img src={professionalImg} alt="Professional"/>Professional</ef-button>
            </ef-button-bar>
          </ef-button-bar>
        </ef-layout>
      </ef-layout>
      {packageLayout === "free" && <Package type="Redistribution Public (Free-to-Air)" pliData={pliData} segmentationData={segmentationData} />}
      {packageLayout === "private" && <Package type="Redistribution Private" pliData={pliData} segmentationData={segmentationData} />}
      {packageLayout === "professional" && <Package type="Internal Professional" pliData={pliData} segmentationData={segmentationData} />}
    </div>
  );
}